import { Component, inject } from '@angular/core';
import { CustomerService } from '@modules/customer/customer.service';

@Component({
    selector: 'app-top-bar-customer',
    imports: [],
    template: '<span class="font-bold">{{ customer().name }}</span>\n'
})
export class TopBarCustomerComponent {
    customerService = inject(CustomerService);
    customer = this.customerService.customer;
}
